import { useTasksByClient } from './useTasksByClient';

/**
 * @deprecated Use `useTasksByClient({ term })` diretamente.
 * Mantido para compatibilidade. Agora retorna TODAS as tasks ligadas ao cliente
 * (não só escalações) — escalações via support_sessions, tasks com contact_id
 * direto e tasks vinculadas a deals do cliente.
 */
export function useEscalationTasksBySearch(term: string | null | undefined) {
  return useTasksByClient({ term });
}
